























































































import Api from "@/api/Api";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      summary: undefined
    };
  },
  async mounted() {
    this.summary = await Api.singleton().call({
      method: "GET",
      resource: "/api/adv/site_summary"
    });
  }
});
